app.controller("SyllabusControlIndexController", ["$scope", "$state", "SyllabusService", "ConfirmModal", "usSpinnerService",
    function ($scope, $state, SyllabusService, ConfirmModal, usSpinnerService) {
        $scope.requests = [];
        $scope.totalItems = 0;
        $scope.format = "dd-MM-yyyy";

        loadPage();

        function loadPage(page, cb) {
            cb = cb || function () {
            };

            usSpinnerService.spin("root");
            SyllabusService.getReviewList().then(function (data) {
                $scope.requests = data;
                $scope.totalItems = data.length;
                usSpinnerService.stop("root");
                cb()
            });
        }

        $scope.open = function (syllabus, $event) {
            $state.go("admin.subject-syllabus", {subjectId: syllabus.subject._id, action: 'review'});
        };
    }
]);
